<!-- src/components/Modal.vue -->
<template>
  <div v-if="isOpen" class="fixed inset-0 z-[999999] flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white p-4 rounded-lg max-w-5xl w-11/12 max-h-[90vh] relative overflow-y-auto modal-content">
      <button 
          @click="closeModal" 
          class="absolute top-4 right-4 text-white font-bold text-lg w-10 h-10 rounded-full flex items-center justify-center shadow-lg gradient-close-btn"
          aria-label="Close Modal"
      >
        <i class="fas fa-times"></i>
      </button>
      <iframe :src="url" class="w-full h-full rounded"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalWindow',
  emits: ['close'],
  props: {
    url: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
@import '~@fortawesome/fontawesome-free/css/all.css';

/* Mobile modal positioning to avoid search bar overlap */
@media (max-width: 768px) {
  .modal-content {
    margin: 80px 16px 16px 16px; /* Add top margin to avoid search bar overlap */
    max-height: calc(90vh - 64px); /* Reduce height to account for top margin */
  }
}

/* Gradient Close Button */
.gradient-close-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.gradient-close-btn:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
</style>